export default {"src":"/_next/static/media/network.fa65f379.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};